import { Box, IconButton } from '@mui/material';
import React from 'react';
/**
 * Renders a horizontal list of icon buttons representing card actions.
 *
 * @param {CardActionsProps} root0 - Component props.
 * @param {Array<{ icon: React.ReactNode, ariaLabel: string, onClick: () => void }>} root0.actions - List of action definitions with icons and handlers.
 * @returns {JSX.Element} A Box containing the rendered action buttons.
 */
export const CardActions = ({ actions }) => {
    return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, pr: actions && actions.length > 0 ? 1 : 0 } }, actions === null || actions === void 0 ? void 0 : actions.map((action) => (React.createElement(IconButton, { key: action.ariaLabel, color: 'primary', onClick: (event) => {
            action.onClick();
            event.stopPropagation();
        }, "aria-label": action.ariaLabel }, action.icon)))));
};
